import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import { reduce as reduce$2 } from './f0787f0a374a0fb53a6711a4f2b4028cc33ea5edade719e288fb8b4080d3e492.cfe-internal.js';
import { reduce as reduce$4 } from './78a2e33fe3b1f63faeaaa17e3176b9f2a4cd378ecafd02e9adbbc0138ed5aaca.cfe-internal.js';
import { reduce as reduce$3 } from './c39fa3093bdea40a37127aec5ef31f93558cef763d0a997e479c6bfd7b739580.cfe-internal.js';
import { reduce as reduce$1 } from './ba9c12aec0f35e9e7d71ac72860c83f93f63950b472e5c730a48b8bab242f3b5.cfe-internal.js';
import { reduce as reduce$5 } from './c41b35a6ad86984b94f66577a96b4137ec8f71cd383e8b3e3d95078c447e1f6b.cfe-internal.js';
import { get } from '../utils/aceb1437b878bf73e9db047b007173ff6e845c291157fcc88aeb319cc459f22a.cfe-internal.js';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    _Object$defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = _Object$keys(source);
    if (typeof _Object$getOwnPropertySymbols === 'function') {
      var _context;
      ownKeys = _concatInstanceProperty(ownKeys).call(ownKeys, _filterInstanceProperty(_context = _Object$getOwnPropertySymbols(source)).call(_context, function (sym) {
        return _Object$getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    _forEachInstanceProperty(ownKeys).call(ownKeys, function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    dirtyHandlerIds: reduce$1(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread({}, action.payload, {
        prevTargetIds: get(state, 'dragOperation.targetIds', [])
      })
    }),
    dragOffset: reduce$2(state.dragOffset, action),
    refCount: reduce$3(state.refCount, action),
    dragOperation: reduce$4(state.dragOperation, action),
    stateId: reduce$5(state.stateId)
  };
}

export { reduce };
